<template>
  <div>
    <b-navbar
      class="topNav"
      type="light">
      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto pt-3 mr-4">
        <b-nav-item
          v-if="!isMobile()"
          href="https://meet.corenexa.com/download/">{{ $t('LOGIN.DOWNLOAD') }}</b-nav-item>
        <b-nav-item href="https://rhelp.corenexa.com/Video">{{ $t('LOGIN.SUPPORT') }}</b-nav-item>
        <b-nav-item-dropdown
          id="lang"
          :text="languageName"
          menu-class="noFocus"
          class="nofocus"
          right>
          <b-dropdown-item
            v-for="(_lang, index) in languages"
            :key="index"
            @click="changeLanguage(_lang.value, _lang.name)">
            {{ _lang.name }}
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-navbar>
    <b-container fluid>
      <b-row
        align-h="center"
        class="pb-5">
        <b-col
          v-if="isSupported()"
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5 loginMaxWidth">
          <b-form
            class="bg-white p-4 rounded shadow light login mt-2"
            @submit="onSubmit"
          >
            <div class="mx-auto my-md-4 text-center logoSize">
              <logo/>
            </div>
            <h3 class="text-center mt-1 mb-5 joinText">{{ $t('LOGIN.BUTTON_JOIN') }}</h3>
            <div class="form-label-group light">
              <b-form-input
                id="meetingID"
                :placeholder="$t('LOGIN.MEETING_PLACEHOLDER')"
                v-model="form.meetingID"
                autocomplete="off"
                type="text"
                required
                autofocus
                class="form-control-light"
              />
              <label for="meetingID">{{ $t('LOGIN.MEETING_PLACEHOLDER') }}</label>
            </div>
            <div
              v-if="!meta_token || (form.name === '' && meta_token)"
              class="form-label-group light">
              <b-form-input
                id="someName"
                :placeholder="$t('LOGIN.NAME_PLACEHOLDER')"
                v-model="form.name"
                type="text"
                required
                class="form-control-light"
              />
              <label for="someName">{{ $t('LOGIN.NAME_PLACEHOLDER') }}</label>
            </div>

            <div class="form-label-group light">
              <b-form-input
                id="pinId"
                v-model="form.pin"
                placeholder="Entry Pin"
                type="text"
                autocomplete="off"
                class="form-control-light"
              />
              <label for="pinId">{{ $t('LOGIN.PIN_PLACEHOLDER') }}</label>
              <small class="form-text text-muted"/>
            </div>
            <hr>
            <b-button
              ref="joinRef"
              :disabled="!isSupported()"
              type="submit"
              class="ml-auto d-block"
              variant="primary-light"
            >
              {{ $t('LOGIN.BUTTON_JOIN') }}
            </b-button>
          </b-form>
        </b-col>
        <b-col
          v-else
          cols="12"
          sm="10"
          md="8"
          lg="5"
          xl="4"
          class="mt-sm-5"
        >
          <div class="bg-white p-4 rounded shadow text-danger-light login mt-2 text-center">
            <div class="m-4">
              <logo/>
            </div>
            <p v-if="isMobile()">{{ $t('LOGIN.MOBILE_UNSUPPORTED') }}</p>
            <p v-if="!isMobile()">{{ $t('LOGIN.BROWSER_UNSUPPORTED') }}</p>
          </div>
        </b-col>
      </b-row>
      <div class="footer clearfix">
        <div class="float-left"><small>© {{ new Date().getFullYear() + " " + $t('LOGIN.COPYRIGHTS') }}</small></div>
        <div class="float-right"><a
          target="_blank"
          href="https://www.corenexa.com/privacy-policy">{{ $t('LOGIN.PRIVACY_POLICY') }}</a></div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { getBrowser, isSupported, isMobile, isIos } from "../functions/browserDetails"
import { loadStorageData, getItem, setItem, getMetaToken, saveMetaToken, getCorenexaToken } from "../functions/storageManager"
import { ref, reactive, watch, onMounted } from "@vue/composition-api"
import Logo from "../icons/Logo"

export default {
  name: 'Login',
  components: {
    Logo
  },
  setup(props, context) {
    const meetingIds = ref([])
    const language = ref('en')
    const languageName = ref('English')
    const languages = ref([{value:"en",name:"English"},{value:"fr",name:"Français"},{value:"sk",name:"Slovenčina"},{value:"es",name:"Español"},{value:"ro",name:"Româna"},{value:"it",name:"Italiano"},{value:"pt",name:"Português"},{value:"de",name:"Deutsch"},{value:"fi",name:"Suomi"},{value:"tr",name:"Türkçe"},{value:"nl",name:"Nederlands"},{value:"zh",name:"简体中文"},{value:"ru",name:"Русский"},{value:"ar",name:"لغة"},{value:"el",name:"Ελληνικά"},{value:"ko",name:"한국어}"},{value:"ja",name:"日本語"},{value:"ur",name:"زبان"},{value:"ne",name:"भाषा"},{value:"kk",name:"Қазақтілі"},{value:"hi",name:"हिन्दी"}])
    const meta_token = ref('');
    const form = reactive ({
      meetingID: '',
      name: '',
      pin: '',
      directly: false
    })
    document.body.style.backgroundColor = "#f8f8f8";

    const browser = getBrowser()
    loadStorageData()
    if (getItem('meetings')) {
      meetingIds.value = getItem('meetings').split(",")
    }
    if (getItem('language') !== undefined) {
      context.root.$i18n.locale = getItem('language')
    } else if (context.root.$route.query.language) {
      context.root.$i18n.locale = context.root.$route.query.language
    } else if (window.default_language != "") {
      context.root.$i18n.locale = window.default_language
    }

    if (getItem('languageName') !== undefined) {
      languageName.value = getItem('languageName')
    } else if (window.default_language != "") {
      languageName.value = window.default_languageName
    }
    language.value = context.root.$i18n.locale


    onCreate(context)

    function onCreate(context) {
      if (context.root.$route.query) {
        form.meetingID = context.root.$route.query.meetingID
        if(context.root.$route.query.pin !== 'required') {
          form.pin = context.root.$route.query.pin
        }

        form.name = context.root.$route.query.name ? context.root.$route.query.name : getItem('meetingData') ? getItem('meetingData').name : ''
        if (context.root.$route.query.r) {
          meta_token.value = context.root.$route.query.r
        } else if (context.root.$route.query.u) {
          meta_token.value = context.root.$route.query.u
        } else if (getCorenexaToken()) {
          meta_token.value = getCorenexaToken()
        } else {
          meta_token.value = getMetaToken()
        }
        // meta_token.value = context.root.$route.query.r ? context.root.$route.query.r : getMetaToken()
        if(meta_token.value) {
          saveMetaToken(meta_token.value)
        }
        if (form.meetingID && form.name !== '') {
          enterMeeting()
        }
      }
      createManifest('')
      if (getItem('directly') !== undefined) form.directly = getItem('directly')
      setItem('debug', 'error')
    }
    function createManifest (branding) {
      let manifestName = 'static/manifest' + branding + '.webmanifest?rnd=132'
      document.getElementById('myManifest').href = manifestName
    }

    function onSubmit (evt) {
      evt.preventDefault()
      enterMeeting()
    }
    function enterMeeting() {
      let index = meetingIds.value.findIndex(value => value == form.meetingID)
      if (index < 0) {
        if(meetingIds.value.length > 4) {
          meetingIds.value.splice(4, meetingIds.value.length - 4)
        }
        meetingIds.value.splice(0, 0, form.meetingID)
        setItem('meetings', meetingIds.value.toString())
      } else {
        meetingIds.value.splice(index, 1)
        meetingIds.value.splice(0, 0, form.meetingID)
        setItem('meetings', meetingIds.value.toString())
      }

      setItem('meetingData', form)
      joinMeeting()
    }

    async function joinMeeting() {
      let isJitsiMeeting = await isJitsi();
      if (isJitsiMeeting) {
        const headers = { "Content-Type": "application/json" }
        if (meta_token.value)
          headers['Authorization'] = 'Bearer ' + meta_token.value
        try {
          var params = 'meetingID=' + form.meetingID
          if (form.pin)
            params += '&pin=' + form.pin
          if (!meta_token.value)
            params += '&username=' + form.name
          let response = await fetch("https://api.corenexa.com/pub/joinMeeting?" + params , { headers })
          let json = await response.json() || {}
          if (json.error) {
            console.log('failed to get meeting details:', json.error)
            context.root.$notify.error("Join meeting: " + json.error)
          } else {
            console.log('meeting details: ', json)
            var queryParams = { meetingID: json.meetingID, meetingName: json.meetingName, domain: json.domain,
                          r: json.jwt, network: json.network }
            if (meta_token.value)
              queryParams['c'] = meta_token.value
            context.root.$router.push({ path: 'joinMeeting', query: queryParams })
          }
        } catch (error) {
          console.log('failed to get meeting details:', error)
        }
      } else {
        context.root.$router.push({ path: 'startMeeting', query: { directly: form.directly } })
      }
    }

    async function isJitsi() {
      const headers = { "Content-Type": "application/json" }
      try {
        let response = await fetch("https://api.corenexa.com/pub/isjitsi/" + form.meetingID, { headers })
        let json = await response.json() || {}
        if (json.error) {
          console.log('failed to get isjitsi meeting details:', json.error)
          return false
        } else {
          return json.jitsi
        }
      } catch (error) {
        console.log('failed to get isjitsi meeting details:', error)
        return false
      }
    }

    function changeLanguage (value, name) {
      context.root.$i18n.locale = value
      languageName.value = name
      setItem('language', value)
      setItem('languageName', name)
    }
    watch(() => form.directly, (directly) => { setItem('directly', directly) })
    return {
      language,
      changeLanguage,
      form,
      meetingIds,
      browser,
      isSupported,
      isMobile,
      loadStorageData,
      getItem,
      setItem,
      onSubmit,
      languages,
      languageName,
      meta_token
    }
  }
}
</script>
<style scoped>
.topNav {
  font-size: 12px;
  padding: .75rem .75rem;
  background-color: transparent!important;
  box-shadow: none!important;
}
.login hr {
  margin: 32px -25px 16px;
}
.logo{
  max-width: 200px;
  line-height: 1;
}
.topNav {
  font-weight: 600;
  padding: 0;
}
.navbar-toggler-icon {
  color: #000000;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue